import React from "react";
import moment from "moment";
import PropTypes from "prop-types";


import Pagination from "components/misc/Pagination";

const OperationsTable = ({
  loading,
  filtered,
  openEditModal,
  handleDelete,
  Tr,
  Td,
  Th,
  StatusBadge,
  LinkText,
  currentPage = 1,
  setCurrentPage = () => {},
  pageSize = 10
}) => {
  // Pagination logic
  const total = filtered.length;
  const totalPages = Math.ceil(total / pageSize);
  const startIdx = (currentPage - 1) * pageSize;
  const endIdx = startIdx + pageSize;
  const pageData = filtered.slice(startIdx, endIdx);

  return (
    <table className="min-w-full bg-white rounded-lg shadow-md">
      <thead>
        <tr>
          <Th>ID</Th>
          <Th>Fecha</Th>
          <Th>Concepto</Th>
          <Th>Tipo</Th>
          <Th>Monto</Th>
          <Th>Descripción</Th>
          <Th>Referencia</Th>
          <Th>Coto</Th>
          <Th>Acciones</Th>
        </tr>
      </thead>
      <tbody>
        {(() => {
          if (loading) {
            return [
              <tr key="loading"><Td colSpan={9}>Cargando...</Td></tr>
            ];
          } else if (filtered.length === 0) {
            return [
              <tr key="empty"><Td colSpan={9}>No hay operaciones encontradas.</Td></tr>
            ];
          } else {
            return [
              ...pageData.map(op => (
                <Tr key={op.id}>
                  <Td>{op.id}</Td>
                  <Td>{moment(op.date).format('YYYY-MM-DD')}</Td>
                  <Td>{op.category}</Td>
                  <Td><StatusBadge type={op.type}>{op.type === "income" ? "Ingreso" : "Egreso"}</StatusBadge></Td>
                  <Td>${op.amount.toLocaleString()}</Td>
                  <Td>{op.description}</Td>
                  <Td>{op.reference}</Td>
                  <Td>{op.neighborhood}</Td>
                  <Td>
                    <LinkText onClick={() => openEditModal(op)}>Editar</LinkText>
                    <LinkText onClick={() => handleDelete(op.id)} className="hover:bg-red-300 ml-2">Eliminar</LinkText>
                  </Td>
                </Tr>
              )),
              // Pagination controls row
              <tr key="pagination-controls">
                <Td colSpan={9}>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                  />
                </Td>
              </tr>
            ];
          }
        })()}
      </tbody>
    </table>
  );
};

OperationsTable.propTypes = {
  loading: PropTypes.bool.isRequired,
  filtered: PropTypes.array.isRequired,
  openEditModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  Tr: PropTypes.elementType.isRequired,
  Td: PropTypes.elementType.isRequired,
  Th: PropTypes.elementType.isRequired,
  StatusBadge: PropTypes.elementType.isRequired,
  LinkText: PropTypes.elementType.isRequired,
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
  pageSize: PropTypes.number
};

export default OperationsTable;
